import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast-title" }
const _hoisted_2 = { class: "toast-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("strong", _hoisted_1, _toDisplayString($props.title), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_2, _toDisplayString($props.description), 1 /* TEXT */)
  ]))
}